import React from "react";
import { Assumptions } from "../types";
import { formatCurrency } from "../utils/formatters";
import "./AssumptionsForm.css";

interface AssumptionsFormProps {
  assumptions: Assumptions;
  goalTotalAssets: number;
  onAssumptionsChange: (assumptions: Assumptions) => void;
  onRecalculate: () => void;
}

const AssumptionsForm: React.FC<AssumptionsFormProps> = ({
  assumptions,
  goalTotalAssets,
  onAssumptionsChange,
  onRecalculate,
}) => {
  const handleInputChange = (field: keyof Assumptions, value: number) => {
    onAssumptionsChange({
      ...assumptions,
      [field]: value,
    });
  };

  return (
    <div className="key-inputs">
      <h2>Goal & Assumptions</h2>
      <div className="inputs-grid">
        <div className="input-group">
          <label>Annual Income</label>
          <input
            type="number"
            value={assumptions.annualIncome}
            onChange={(e) =>
              handleInputChange("annualIncome", parseFloat(e.target.value) || 0)
            }
          />
        </div>
        <div className="input-group">
          <label>Max Target Interest (%)</label>
          <input
            type="number"
            step="0.01"
            value={assumptions.planMTI}
            onChange={(e) =>
              handleInputChange("planMTI", parseFloat(e.target.value) || 0)
            }
          />
        </div>
        <div className="input-group">
          <label>Max DTA (%)</label>
          <input
            type="number"
            step="0.01"
            value={assumptions.maxDTA}
            onChange={(e) =>
              handleInputChange("maxDTA", parseFloat(e.target.value) || 0)
            }
          />
        </div>
        <div className="input-group">
          <label>Min DSCR</label>
          <input
            type="number"
            step="0.1"
            value={assumptions.minDSCR}
            onChange={(e) =>
              handleInputChange("minDSCR", parseFloat(e.target.value) || 0)
            }
          />
        </div>
        <div className="input-group">
          <label>Safety Buffer (months)</label>
          <input
            type="number"
            value={assumptions.resMonths}
            onChange={(e) =>
              handleInputChange("resMonths", parseFloat(e.target.value) || 0)
            }
          />
        </div>
      </div>
      <button onClick={onRecalculate}>Recalculate Plan</button>
      <div className="goal-display">
        Goal Total Assets: {formatCurrency(goalTotalAssets)}
      </div>
    </div>
  );
};

export default AssumptionsForm;
